import { render, staticRenderFns } from "./HeadTeacher.vue?vue&type=template&id=f2da8b0e&scoped=true"
import script from "./HeadTeacher.vue?vue&type=script&lang=js"
export * from "./HeadTeacher.vue?vue&type=script&lang=js"
import style0 from "./HeadTeacher.vue?vue&type=style&index=0&id=f2da8b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2da8b0e",
  null
  
)

export default component.exports